import React from 'react'
import T from 'i18n-react'

import FormTitle from 'components/fulcrum/formTitleWithRisk/index'
import Slider from 'components/fulcrum/slider/Slider'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import List from './List'
import styles from './styles.scss'
import { composeP, type } from 'ramda'

class Clock extends React.Component {

  onOcBinValueChange(changedValue){
    const {
      onChange,
      source,
    } = this.props

    const value = source.find(source => parseInt(changedValue) === source.ocBin)
    onChange(value)
  }

  onBaseValueChange(changedValue){
    const {
      onChange,
      source,
      ocBin
    } = this.props

    // const value = source.find(source => changedValue === source.baseClock && ocBin === source.ocBin)

    const value = source[changedValue]
    onChange(value)
  }

  // use changed value and go through list and get the absolute differences.
  // search for the value with the smallest difference
  onBoostValueChange(list, changedValue){
    const {
      onChange,
      source,
      baseValue,
      ocBin
    } = this.props

    // Get closest boost clock to changed value
    const closestBoost = list.reduce((closestObject, curValue) => {
      const curDiff = Math.abs(changedValue - curValue)
      return closestObject.diff <  curDiff ? closestObject : {value: curValue, diff: curDiff}
    }, {value: list[0], diff: Math.abs(list[0] - changedValue)})

    // Find source with matching boost and base clock
    const value = source.find(source => (baseValue === source.baseClock && closestBoost.value === source.boostClock && ocBin === source.ocBin))
    onChange(value)
  }

  getBaseDropdownSources(baseSources) {
    return baseSources.map((clockValue) => {
      return {
        value: clockValue,
        label: clockValue + ' MHz'
      }
    })
  }

  getOcBinDropdownSources(ocBinSources) {
    return ocBinSources.map(ocBin => {
      return {
        value: ocBin.toString(),
        label: ocBin.toString()
      }
    })
  }

  render() {
    const {
      ocBin,
      minBoost,
      maxBoost,
      baseValue,
      boostValue,
      offsetValue,
      tgpValue,
      ocBinSources,
      baseSources,
      boostSources,
      isRisk,
    } = this.props

    let baseDropdownSources = this.getBaseDropdownSources(baseSources)

    baseDropdownSources = baseDropdownSources.map((source, index) => {
      source['value'] = index
      return source
    })
    let newBaseValue = baseSources.indexOf(baseValue)
    const ocBinEnabled = ocBinSources.some(ocBin => ocBin > 0)
    const ocBinDropdownSources = this.getOcBinDropdownSources(ocBinSources)
    const offsetEnabled = offsetValue
    const ocBinJSX = ocBinEnabled && (
      <FormTitle
        title={T.translate('project_creation.custom.oc_bin')}
        isRisk={isRisk}
      >   
        <div className={styles.sublistItem}>
          <Dropdown 
            source={ocBinDropdownSources}
            value={ocBin.toString()}
            onChange={this.onOcBinValueChange.bind(this)}
          />
        </div>
      </FormTitle>
    )
    
    
    return (
      <div>
        <FormTitle
          title={T.translate('project_creation.custom.base_clock')}
          isRisk={isRisk}
        >
          <Dropdown 
            source={baseDropdownSources}
            value={newBaseValue}
            onChange={this.onBaseValueChange.bind(this)}
          />
        </FormTitle>
        
        <List
          items={[
            { name: 'OC BIN', value: ocBinJSX, enabled: ocBinEnabled, type: 'Dropdown' },
            { name: 'VF Offset', value: `${offsetValue} MHz`, enabled: offsetEnabled, type: 'TextField' },
            { name: 'TGP min', value: `${tgpValue} Watts`, enabled: true, type: 'TextField' }
          ]}
        />

        <FormTitle
          title={T.translate('project_creation.custom.boost_clock')}
          isRisk={isRisk}
        >
          <Slider
            editable
            step={1}
            min={minBoost}
            max={maxBoost}
            value={boostValue}
            onChange={this.onBoostValueChange.bind(this, boostSources)}
          />
        </FormTitle>
      </div>
    )
  }
}

export default Clock
